import { render, staticRenderFns } from "./ComboboxPacote.vue?vue&type=template&id=28d593ac&"
import script from "./ComboboxPacote.vue?vue&type=script&lang=js&"
export * from "./ComboboxPacote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports